import React, { useMemo, useState, useEffect, useRef } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  InputGroup,
  Button
} from "reactstrap"
import { useNavigate } from "react-router-dom"
import Breadcrumbs from "components/Common/Breadcrumb"
import Flatpickr from "react-flatpickr";
import TableContainerV1 from "components/Common/TableContainerV1"
import moment from "moment"
import { getCustomerQueryList } from "helpers/UAM/inquiry.helper"
import ViewInquiry from "./ViewQuery"
import { isEmpty } from "lodash"

const Query = () => {
  document.title = "Past Queries | DMS "
  const navigate = useNavigate();
  const [inquiryList, setInquiryList] = useState([]);
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    status: ''
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [inquiryInfo, setInquiryInfo] = useState({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action", "dealer"],
  });

  const flatpickrRef = useRef(null);

  const { roleName } = JSON.parse(localStorage.getItem("user"))

  const getInquiry = async (bodyData) => {
    let findInquiryList = getCustomerQueryList
    const response = await findInquiryList(bodyData);
    if (response.status) {
      setInquiryList(response.data.data);
      const { totalItems, totalPages, currentPage } = response.data
      setPagination({
        pageIndex: currentPage,
        pageCount: totalPages,
        totalRecords: totalItems,
      })
    } else {
      setInquiryList([]);
      setPagination({
        pageIndex: 0,
        pageCount: 0,
        totalRecords: 0,
      })
    }
  }

  useEffect(() => {
    const bodyData = {
      page: currentPage,
      searchKey: searchValue,
      limit: pageSize,
      columnName: columnId,
      sortingOrder: sortingOrderStatus,
      filterType: filters
    }
    getInquiry(bodyData);
  }, [searchValue, pageSize, columnId, sortingOrderStatus, currentPage]);

  const handlePageChange = (page, pageSize) => {
    setPageSize(pageSize);
    setCurrentPage(page);
  }

  const handleSortColumn = (option) => {
    if (option.column == "dealer") return
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
  };

  const handleSearchFilter = (value) => {
    setSearchValue(value);
    setCurrentPage(1)
  };

  const handleClearSearch = () => {
    setSearchValue("");
    setFilters({
      startDate: '',
      endDate: '',
      status: ''
    })
    flatpickrRef.current.flatpickr.clear()
    setCurrentPage(1);
    let bodyData = {
      filterType: {
        startDate: '',
        endDate: '',
        status: ''
      },
      page: 1,
      searchKey: "",
      limit: pageSize,
      columnName: columnId,
      sortingOrder: sortingOrderStatus,
    }

    getInquiry(bodyData)

  };

  const ProductDescription = ({ value }) => {
    if (value && value.length > 50) {
      let newValue = value.substring(0, 50) + '...';
      return (
        <span className="d-inline" tabIndex="0" data-toggle="tooltip" title={value} dir="top" data-placement="top">
          {newValue}
        </span>
      )
    }
    return (
      <span>{value}</span>
    )
  }

  const handleAuditLogs = (data) => {
    setInquiryInfo(data)
  }

  const getStatusComponent = (val) => {
    const statusMap = {
      resolve: <p className="bg-green rounded-pill status-pill text-white  d-flex justify-content-center p-1">Resolved</p>,
      lost: <p className="bg-danger rounded-pill status-pill text-white  d-flex justify-content-center p-1">Closed (Lost)</p>,
      open: <p className="bg-warning rounded-pill status-pill text-white  d-flex justify-content-center p-1" >Open</p>,
    };

    return statusMap[val] || null;
  };

  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        Cell: cellProps => {
          return cellProps.value
        },
      },
      {
        Header: "Dealer Name",
        accessor: "dealer",
        Cell: cellProps => {
          return (cellProps.value?.entityName ? cellProps.value?.entityName : "")
        },
      },
      {
        Header: "Query",
        accessor: "description",
        width: '100px',
        filterable: true,
        Cell: cellProps => {
          return <ProductDescription value={cellProps.value} />
        },
      },
      {
        Header: "Query Date",
        accessor: "createdAt",
        filterable: true,
        Cell: cellProps => {
          return cellProps.value ? moment(cellProps.value).format("MMM DD, YYYY HH:mm A") : ""
        },
      },
      {
        Header: "Status",
        accessor: "queryStatus",
        filterable: true,
        Cell: (cellProps) => getStatusComponent(cellProps?.value)
      },
      {
        Header: "Action",
        Cell: cellProps => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-horizontal font-size-18"></i>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => {
                    const edit = cellProps.row.original
                    handleEdit(edit)
                  }}
                >
                  <i
                    className="mdi mdi-pencil font-size-16 text-success me-1"
                    id="edittooltip"
                  ></i>
                  Edit
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Edit
                  </UncontrolledTooltip>
                </DropdownItem>
                {/* <DropdownItem
                  onClick={() => {
                    handleAuditLogs(cellProps.row.original)
                  }}
                >
                  <i
                    className="bx bx-log-in-circle font-size-16 text-success me-1"
                    id="viewtooltip"
                  ></i>
                  Audit Logs
                  <UncontrolledTooltip placement="top" target="viewtooltip">
                    Audit Logs
                  </UncontrolledTooltip>
                </DropdownItem> */}
              </DropdownMenu>
            </UncontrolledDropdown>
          )
        },
      },
    ],
    []
  )

  const handleEdit = arg => {
    const id = arg.id
    const enCodedId = btoa(id)
    navigate(`/${roleName}/query/edit/${enCodedId}`);
  }

  const handleStatusChange = (value) => {
    setFilters({
      ...filters,
      status: value,
    })
    const bodyData = {
      filterType: {
        ...filters,
        status: value,
      },
      page: currentPage,
      searchKey: searchValue,
      limit: pageSize,
      columnName: columnId,
      sortingOrder: sortingOrderStatus,
    }
    getInquiry(bodyData)
  }

  const handleDateFilter = () => {
    const bodyData = {
      filterType: filters,
      page: currentPage,
      searchKey: searchValue,
      limit: pageSize,
      columnName: columnId,
      sortingOrder: sortingOrderStatus,
    }
    getInquiry(bodyData)
  }

  const handleDateChange = (selectedDates) => {
    if (selectedDates.length === 2) {
      setFilters({
        ...filters,
        startDate: selectedDates[0],
        endDate: selectedDates[1],
      })
    }
  };

  const customeFilterSection = (
    <div className="d-flex align-items-center justify-content-start">
      <div className="text-sm-start">
        <select className="form-select  me-3 show-dropdown" style={{ width: "150px" }}
          value={filters.status}
          onChange={(e) => {
            const value = e.target.value;
            handleStatusChange(value)
          }}
        >
          <option selected={filters.isActive == ""} value={""}>All</option>
          <option selected={filters.status == 'resolve'} value={'resolve'}>Resolved</option>
          <option selected={filters.status == 'open'} value={'open'}>Open</option>
          <option selected={filters.status == 'lost'} value={'lost'}>Closed (Lost)</option>
        </select>
      </div>
      <InputGroup>
        <Flatpickr
          ref={flatpickrRef}
          className="form-control"
          placeholder="Start Date - End Date"
          options={{
            mode: 'range',
            dateFormat: 'd-m-Y'
          }}
          value={[filters?.startDate, filters?.endDate]}
          onChange={handleDateChange}
        />
        <Button variant="primary"
          onClick={handleDateFilter}
          style={{ backgroundColor: "#344fa0", border: "none" }}>
          Go
        </Button>
      </InputGroup>
    </div>
  )

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Query" breadcrumbItem="Past Queries" />
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                <Col>
                  <TableContainerV1
                    columns={columns}
                    data={inquiryList}
                    pagination={pagination}
                    handlePageChange={handlePageChange}
                    handleSearchFilter={handleSearchFilter}
                    searchHelperText={"Search by Description, Inquiry Date"}
                    customFilterSection={customeFilterSection}
                    sortOptions={sortingOptions}
                    handleSortColumn={handleSortColumn}
                    handleClearSearch={handleClearSearch}
                    className="custom-header-css"
                  />
                </Col>
                <ViewInquiry show={!isEmpty(inquiryInfo)} handleClose={() => setInquiryInfo({})} inquiryInfo={inquiryInfo} />

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Query